import { render, staticRenderFns } from "./AOI_SidebarContent.vue?vue&type=template&id=064675c4&scoped=true&"
import script from "./AOI_SidebarContent.vue?vue&type=script&lang=js&"
export * from "./AOI_SidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./AOI_SidebarContent.vue?vue&type=style&index=0&id=064675c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064675c4",
  null
  
)

export default component.exports